import { Injectable } from "@angular/core";
import { AdLogEvent } from "src/app/interfaces/log/ad-log";
import { LogService } from "../log.service";

@Injectable({
  providedIn: 'root'
})
export class AdLogService {
  constructor(
    private logService: LogService
  ) { }

  adImpression(params?: Record<string, string | number | undefined>): void {
    this.adEventLogging(AdLogEvent.AD_IMPRESSION, params)
  }
  adButtonClicked(params?: Record<string, string | number | undefined>): void {
    this.adEventLogging(AdLogEvent.AD_BUTTON_CLICKED, params)
  }
  adBannerClicked(params?: Record<string, string | number | undefined>): void {
    this.adEventLogging(AdLogEvent.AD_BANNER_CLICKED, params)
  }
  adCloseButtonClicked(params?: Record<string, string | number | undefined>): void {
    this.adEventLogging(AdLogEvent.AD_CLOSE_BUTTON_CLICKED, params)
  }

  private adEventLogging(event, params?: Record<string, string | number | undefined>): void {
    const url: URL = new URL(window.location.href);
    this.logService.eventLogging(event, {
      from: url.pathname,
      ...params
    })
  }
}